
// React Imports
import {useSelector} from "react-redux";
import * as React from "react";

// Mui Imports


// App Imports
import ContractSearchGrid from "../Contracts/ContractSearchGrid";
import WorkQueueContractGrid from "../Contracts/WorkQueueContractsGrid";


// main function
export default function WorkQueueBodyLeft(props) {

    const controlsPropertyDropdownTitleId = useSelector((state) => state.workQueueSlc.value.propertyDropdownTitleId);
    const selectorPropertySearchState = useSelector((state) => state.workQueueSlc.value.propertySearchState);
    const selectorUnstructuredSearchState = useSelector((state) => state.workQueueSlc.value.unstructuredSearchState);



    // ****************** BEGIN RETURN ****************************

    return(
        <div>
            {
                (selectorPropertySearchState === true && controlsPropertyDropdownTitleId > 0) &&
                <WorkQueueContractGrid/>
            }
            {
                (selectorUnstructuredSearchState === true ) &&
                <ContractSearchGrid/>
            }

        </div>
    )

    // ****************** END RETURN ****************************

}